export const GetQueryParam = (key: string) => new URLSearchParams(window.location.search).get(key)